import { ReactElement, useEffect, useState } from 'react';
import { ButtonGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SortType } from 'services/store';
import CustomButton from '../../CustomButtonGroup';

type PropsType = {
  initialValue: SortType;
  onUpdate: (popularity: SortType) => void;
};

const MobilePopularOrRecentSortingFilter = (props: PropsType): ReactElement => {
  const { initialValue, onUpdate } = props;
  const { t } = useTranslation();
  const [currentSortingType, setCurrentSortingType] =
    useState<SortType>(initialValue);

  useEffect(() => {
    setCurrentSortingType(initialValue);
  }, [initialValue]);

  useEffect(() => {
    onUpdate(currentSortingType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSortingType]);

  const textForSortingFilterType = (type: SortType): string => {
    if (type === SortType.Popular) {
      return t('filtersBar:mobile.popular');
    }
    return t('filtersBar:mobile:recent');
  };

  const onSortingTypeClicked = (type: SortType): void => {
    // clicking on the item that is already selected should not close the window
    if (type === currentSortingType) return;
    setCurrentSortingType(type);
  };

  const classNameForSortingType = (type: SortType): boolean => {
    if (type === currentSortingType) {
      return true;
    }
    return false;
  };

  return (
    <>
      <ButtonGroup
        size="large"
        variant="outlined"
        aria-label="outlined button group"
        fullWidth
      >
        <CustomButton
          selectedFilter={classNameForSortingType(SortType.Popular)}
          size="large"
          onClick={() => {
            onSortingTypeClicked(SortType.Popular);
          }}
        >
          {textForSortingFilterType(SortType.Popular)}
        </CustomButton>
        <CustomButton
          selectedFilter={classNameForSortingType(SortType.Recent)}
          size="large"
          onClick={() => {
            onSortingTypeClicked(SortType.Recent);
          }}
        >
          {textForSortingFilterType(SortType.Recent)}
        </CustomButton>
      </ButtonGroup>
    </>
  );
};

export default MobilePopularOrRecentSortingFilter;
